import { buildQueryString } from "../../../helpers/buildQueryString";
import { publicRequest } from "../../../requestMeth";
import {
  heatmapFailure,
  heatmapStart,
  heatmapSuccess,
} from "../../reducers/analysis/analysisRedux";

const pad = (n) => (n < 10 ? `0${n}` : n);
const formatDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

const toArgentinaDayRangeUTC = (startD, endD) => {
  if (!startD) return { startDateTime: undefined, endDateTime: undefined };

  const s = new Date(startD);
  const e = endD ? new Date(endD) : new Date(startD);

  const startLocal = new Date(
    s.getFullYear(),
    s.getMonth(),
    s.getDate(),
    0,
    0,
    0,
    0,
  );

  const endLocal = new Date(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    23,
    59,
    59,
    999,
  );

  return {
    startDateTime: startLocal.toISOString(),
    endDateTime: endLocal.toISOString(),
  };
};

const fetchData = async (
  dispatch,
  token,
  endpoint,
  start,
  end,
  frec,
  mac,
  extra = {},
  param,
  phase,
  id_slave,
) => {
  dispatch(heatmapStart());

  try {
    const toValidDate = (v) => {
      if (!v) return null;
      const d = v instanceof Date ? v : new Date(v);
      return Number.isNaN(d.getTime()) ? null : d;
    };

    const startD = toValidDate(start);
    const endD = toValidDate(end);
    const hasRange = Boolean(startD && endD);
    const hasFrec =
      frec !== undefined && frec !== null && String(frec).trim() !== "";
    const frecParam = hasFrec ? String(frec).trim() : undefined;
    const startFormat = startD ? formatDate(startD) : undefined;
    const { startDateTime, endDateTime } = toArgentinaDayRangeUTC(startD, endD);
    const endFormatPlus1 = endD ? formatDate(endD) : undefined;

    let queryObj;

    if (hasFrec) {
      queryObj = {
        startDate: startFormat,
        endDate: endFormatPlus1,
        day: undefined,
        frec: frecParam,
        mac,
        param,
        phase,
        meter: id_slave,
        ...extra,
      };
    } else {
      queryObj = {
        startDate: hasRange ? startFormat : undefined,
        endDate: hasRange ? endFormatPlus1 : undefined,
        day: !hasRange ? startFormat : undefined,
        frec: undefined,
        mac,
        param,
        meter: id_slave,
        ...extra,
      };
    }

    const query = buildQueryString(queryObj);

    const res = await publicRequest.get(`/analysis/${endpoint}?${query}`, {
      headers: { token: `Bearer ${token}` },
    });

    let data = res.data;

    if (hasRange && Array.isArray(data) && data.length) {
      const minTs = Date.parse(startDateTime);
      const maxTs = Date.parse(endDateTime);

      const pickTs = (row) => row?.timestamp || row?.date_time;
      const parseTs = (row) => Date.parse(pickTs(row));

      data = data.filter((row) => {
        const ts = parseTs(row);
        return Number.isFinite(ts) && ts >= minTs && ts <= maxTs;
      });
    }
    dispatch(heatmapSuccess(data));
    return data;
  } catch (error) {
    dispatch(heatmapFailure());
  }
};

export const getHeatmap = (
  dispatch,
  token,
  start,
  end,
  frec,
  mac,
  extra,
  meterSelected,
  phase,
  id_slave,
) => {
  const param = meterSelected === "potencia activa" ? "potActiva" : "eActiva";
  return fetchData(
    dispatch,
    token,
    "heatmap",
    start,
    end,
    frec,
    mac,
    extra,
    param,
    phase,
    id_slave,
  );
};
